export const MetricsSymbols = {
    MetricsService: Symbol.for("MetricsService"),
    MetricsProvider: Symbol.for("MetricsProvider")
}
